// https://vuex.vuejs.org/en/mutations.html
import PermissionManager from "../../helper/permision"
import store from "../../store";
import axios from "axios";
export default {
  auth_request(state) {
    state.authStatus = "loading";
  },
  auth_success(state, { token }) {
    state.authStatus = "success";
    state.token = token;
  },
  authStatus(state) {
    state.authStatus = "success";
  },
  auth_error(state) {
    state.authStatus = "error";
  },
  logout(state) {
    state.authStatus = null;
    state.token = null;
    state.userMe =null;
    axios.defaults.headers.common.Authorization = null;
    localStorage.removeItem("token");
  },
  userMe(state, payload) {
    state.userMe = payload;
    // const contract = payload.contracts.rows[payload.contracts.rows.length - 1]
    let contract;
    if (payload.contracts.rows.length > 1) {
      contract = payload.contracts.rows[payload.contracts.rows.length - 1]
      state.userMe.lastContract = contract
    }

    else {
      contract = payload.contracts.rows[0]
      state.userMe.lastContract = contract
    }

    // state.permission = contract
    const data = store.state
    // console.log("data.employees.employees.length",data.employees.employees.length)
    const permissionManagers = new PermissionManager(
      payload.role,
      data.employees.employees.length,
      contract.max_employees,
      data.geoPlace.length,
      contract.max_branches,
      contract.finished_at,
      contract.isTrial,
      false);

    state.permission = permissionManagers.createPermissionObject()

  },
};
